import gql from 'graphql-tag'

export const LATEST_PAGE_VERSION = gql`
    query loadPage($pageID: ID!) {
        loadPage(pageID: $pageID) {
            id
            createdAt
            updatedAt
            currentVersion {
                ID
                createdAt
                updatedAt
                updatedBy {
                    id
                    name
                }
            }
        }
    }
`
